import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Section } from 'src/components/Section';
import { useCurrentOrganization } from 'src/view/hooks';
import { OrganizationRolePermission } from 'src/domain/organization';
import { useCreatorRolePermission } from 'src/view/hooks/useCreatorRolePermission';

import { CreateMessageForm } from './CreateMessageForm';
import { TextIcon } from 'src/components/Icons/TextIcon';
import { BackIcon } from 'src/components/Icons/icons';

export const CreateMessagePage = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { organizationId } = useCurrentOrganization();
    const canSendMessagesToAll = useCreatorRolePermission(
        OrganizationRolePermission.sendMessagesToAll,
    );

    if (!organizationId) {
        return (
            <div className="text-sm text-mongooseGray">
                {t('modules.messages.form.noOrganization')}
            </div>
        );
    }

    return (
        <Section
            title={t('modules.messages.createTitle')}
            action={
                <Link
                    to="/app/messages"
                    className="primary-btn-small flex items-center gap-1 pl-2 pr-4 py-1 lg:hidden"
                >
                    <TextIcon SVG={BackIcon} />
                    {t('modules.messages.backToList')}
                </Link>
            }
        >
            <CreateMessageForm
                onSuccess={() => {
                    history.push('/app/messages');
                }}
                organizationId={organizationId}
                canSendToAll={canSendMessagesToAll}
            />
        </Section>
    );
};
